import { Button, Col, Row, Card, Container } from "react-bootstrap";
import "./About.css";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import aboutimg from "../assets/images/about-img.jpg";
import about from "../assets/images/about.jpg";
import Footer from "./Footer";
import { motion } from "framer-motion";

function AboutUs() {
  const navigate = useNavigate();

  return (
    <>
      <div className="about-v2">
        <div style={{ height: "130px" }}>
          <Header />
        </div>

        <Container className="about-v2-hero">
          <Row className="align-items-center g-5">
            <Col lg={6} md={12}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <h1 className="about-v2-title">About Us</h1>
                <p className="about-v2-lead">
                  At <strong>Lyra Infotech</strong>, we engineer scalable
                  digital products built for global reach and long-term impact.
                  Join a team that goes beyond features to architect platforms
                  that shape how people experience technology.
                </p>
                <p className="about-v2-lead">
                  From idea validation to launch and continuous improvement, our
                  team creates high-performance products published on the Play
                  Store and App Store, reaching thousands of users worldwide.
                </p>

                <Button
                  className="about-v2-btn"
                  onClick={() => navigate("/contact")}
                >
                  Enquiry Now
                </Button>
              </motion.div>
            </Col>
            <Col lg={6} md={12} className="text-lg-end">
              <motion.img
                src={about}
                alt="About"
                className="about-v2-image"
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
              />
            </Col>
          </Row>
        </Container>

        <Container className="about-v2-cards">
          <Row className="g-4 align-items-stretch">
            <Col lg={4} md={6} className="d-flex">
              <Card className="about-v2-card w-100">
                <Card.Body className="d-flex flex-column">
                  <div className="about-v2-card-icon" aria-hidden="true">
                    ◎
                  </div>
                  <h3 className="about-v2-card-title">Our Core Value</h3>
                  <ul className="about-v2-list">
                    <li>Integrity & Transparency</li>
                    <li>Product Excellence</li>
                    <li>Scalable Innovation</li>
                    <li>Scalable Innovation</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={6} className="d-flex">
              <Card className="about-v2-card w-100">
                <Card.Body className="d-flex flex-column">
                  <div className="about-v2-card-icon" aria-hidden="true">
                    ◉
                  </div>
                  <h3 className="about-v2-card-title">Our Vision</h3>
                  <p className="about-v2-card-text">
                    Our vision is to build a globally recognized digital
                    ecosystem capable of serving millions today — and scaling to
                    billions tomorrow.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={12} className="d-flex">
              <Card className="about-v2-card w-100">
                <Card.Body className="d-flex flex-column">
                  <div className="about-v2-card-icon" aria-hidden="true">
                    ◎
                  </div>
                  <h3 className="about-v2-card-title">Our Mission</h3>
                  <p className="about-v2-card-text">
                    Our mission is to architect scalable, user-centric platforms
                    that combine innovation, performance, and intelligent
                    infrastructure to deliver transformative digital experiences
                    worldwide.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>

        <Footer />
      </div>
    </>
  );
}

export default AboutUs;
